import React, { ReactNode } from 'react';
import Label from './Label';

interface ILabels {
  labels: ICertification[];
  panelItem?: ReactNode;
  panelTitle?: string;
}

const Labels = ({ labels, panelItem, panelTitle }: ILabels) => {
  return (
    <>
      {labels &&
        labels.map((label) => (
          <Label
            image={label?.image}
            name={label?.name}
            panelItem={panelItem}
            panelTitle={panelTitle}
            key={label?.id}
          />
        ))}
    </>
  );
};

export default Labels;
